import React from "react";
import PageHero from "../components/PageHero";
import {
  HeartPulse, Stethoscope, Siren, Pill, ScanLine,
  FlaskConical, UserRound, BedDouble, HandHeart,
} from "lucide-react";
import { FACILITIES } from "../data/site";

const ICONS = { HeartPulse, Stethoscope, Siren, Pill, ScanLine, FlaskConical, UserRound, BedDouble, HandHeart };

export default function Facilities() {
  return (
    <div data-testid="facilities-page">
      <PageHero
        eyebrow="Facilities"
        title={<>Hospital infrastructure <span className="italic text-brand-maroon">you can trust.</span></>}
        subtitle="Pathology, Radiology, ICU, Modular OT, 24x7 ER, in-house pharmacy and clean comfortable wards — all built for safer outcomes."
        image="https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=1400&q=85"
      />

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {FACILITIES.map((f) => {
            const Icon = ICONS[f.icon] || Stethoscope;
            return (
              <article
                key={f.key}
                data-testid={`facility-detail-${f.key}`}
                className="rounded-3xl overflow-hidden bg-white border border-brand-beige hover:shadow-lg transition"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={f.image} alt={f.title} className="w-full h-full object-cover" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 text-brand-maroon text-xs uppercase tracking-[0.18em] font-bold">
                    <Icon size={14} /> Facility
                  </div>
                  <h3 className="font-serif-display text-2xl text-brand-ink mt-2">{f.title}</h3>
                  <p className="text-sm text-brand-ink/65 mt-2 leading-relaxed">{f.summary}</p>
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </div>
  );
}
